import { Injectable } from '@angular/core';
import { AppHttpClient } from '../api.interceptor';
import { environment } from '@env/environment';
import { HelpersService } from '@base/shared/services/helpers.service';

import * as staticData from './registration.static-data.json';

@Injectable()
export class RegistrationRequests {
  private config = environment;

  constructor(
    private http: AppHttpClient,
    private helpers: HelpersService
  ) {
  }


  /**
   * Get projects lists
   */
  getProjects(payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.projects}/slim`;
    return this.http.get(url, payload).toPromise();
  }

  getProjectsForSubmitter(payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/submitter`;
    return this.http.get(url, payload).toPromise();
  }

  getProjectDetails(projectId){
    const url = `${this.config.baseUrl}/v2/${this.config.services.projects}/${projectId}/slim`;
    return this.http.get(url).toPromise();
  }

  getStates(){
    return staticData['default'].states;
  }

  /**
   * Get projects lists
   */
  getSections(projectId, payload?) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.projects}/${projectId}/registrations/sections`;
    return this.http.get(url, payload).toPromise();
  }

  /**
   * Get projects lists
   */
  getFields(projectId, payload?) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.projects}/${projectId}/registrations/fields`;
    return this.http.get(url, payload).toPromise();
  }


  /**
   * Get Contratcs list
   */
  getContracts(projectId, payload?) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.projects}/${projectId}/contracts`;
    return this.http.get(url, payload).toPromise();
  }

  /**
   * new registration
   */
  postWorker(projectId, payload?) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.projects}/${projectId}/workers`;
    return this.http.post(url, payload).toPromise();
  }

  updateWorker(projectId, workerId, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.projects}/${projectId}/register_workers/${workerId}`;
    return this.http.put(url, payload).toPromise();
  }

  /**
   * search for profile
   */
  searchProfile(projectId, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.projects}/${projectId}/register_workers/search`;
    return this.http.get(url, payload).toPromise();
  }

}
